import API from "serviceshift-ui/api-client";
import moment from "moment-timezone";
import { groupBy } from "@/lib/helpers.js";

export default {
  createTodo({ dispatch }, data) {
    return API.makeRequest(`/v2/todo_items`, {
      method: "POST",
      data
    }).then(() => {
      return dispatch("fetchPendingNotificationCount");
    });
  },
  fetchAdmins({ commit }) {
    return API.makeRequest(`/v2/admins`, {
      method: "GET"
    }).then((response) => {
      return commit("replace", {
        state: "admins",
        data: response.data
      });
    });
  },
  fetchAdminsForCall({ commit }, id) {
    return API.makeRequest(`/v2/phone_calls/${id}/assignable`, {
      method: "GET"
    }).then((response) => {
      return commit("replace", {
        state: "admins",
        data: response.data
      });
    });
  },
  fetchTodo(_, id) {
    return API.makeRequest(`/v2/todo_items/${id}`, {
      method: "GET"
    });
  },
  updateTodo({ dispatch }, data) {
    return API.makeRequest(data.links.todo_update, {
      method: "PUT",
      data
    }).then(() => {
      return dispatch("fetchPendingNotificationCount");
    });
  },
  setToDoCompleted({ dispatch }, action_link) {
    return API.makeRequest(action_link, {
      method: "PUT"
    }).then(() => {
      return dispatch("fetchPendingNotificationCount");
    });
  },
  updatePendingNotificationCount({ commit }, count) {
    return commit("replace", {
      state: "pendingNotificationCount",
      data: count
    });
  },
  fetchPendingNotificationCount({ dispatch }) {
    return API.makeRequest("/v2/todo_items/count", {
      method: "GET"
    }).then((res) => {
      return dispatch("updatePendingNotificationCount", res.data.todos);
    });
  },
  fetchMyTodos({ commit }) {
    return API.makeRequest("/todos/assigned_to_me.json?plain=true", {
      method: "GET"
    }).then((response) => {
      const todos = response.data || [];
      const sortedTodos = todos
        // new Date(0) is small hack for correct sort group of todos.
        // Todos without due by will be at the end of the list
        .map((todo) => (!todo.dueBy ? { ...todo, dueBy: new Date(0) } : todo))
        .sort(
          (a, b) => new Date(b.dueBy).valueOf() - new Date(a.dueBy).valueOf()
        );

      commit("replace", {
        state: "myTodos",
        data: {
          count: todos.length,
          grouped: groupBy(
            sortedTodos.map((todo) => {
              const dueBy = moment(todo.dueBy).format("MM/DD/YYYY");

              function getDueByString() {
                // 01/01/1970 is formatted new Date(0)
                if (dueBy !== "01/01/1970") {
                  const now = moment();
                  const isOverdue = now.diff(dueBy, "days") > 0;

                  return isOverdue ? `Overdue: ${dueBy}` : `Due by: ${dueBy}`;
                }

                return "No due by:";
              }

              return {
                ...todo,
                dueBy: getDueByString()
              };
            }),
            "dueBy"
          ),
          source: sortedTodos
        }
      });
    });
  }
};
